import Video from '../components/Video';
import BannerCarousel from "./page-partials/BannerCarousel";
import VideoWithCarousel from "./page-partials/VideoWithCarousel";
import TwoColumns from "./page-partials/TwoColumns";
import ListWithCarousel from "./page-partials/ListWithCarousel";
import ContentWithImage from "./page-partials/ContentWithImage";
import Quiz from "../components/Quiz";



const Page = ({ data }) => {

    return (
      <div className="page">
        <div className="page-content">
          {data.template !== "quiz" && (
            <>
              <div
                className="title"
                dangerouslySetInnerHTML={{
                  __html: data.title,
                }}
              />
              {data.content &&
                data.template !== "content-with-image" &&
                data.content &&
                data.template !== "list-with-carousel" && (
                  <div
                    className="content"
                    dangerouslySetInnerHTML={{
                      __html: data.content,
                    }}
                  />
                )}
            </>
          )}

          {data.template === "video" && <Video embedId={data.videoId} />}

          {data.template === "banner-and-carousel" && (
            <BannerCarousel props={data} />
          )}

          {data.template === "video-with-carousel" && (
            <VideoWithCarousel props={data} />
          )}

          {data.template === "content-with-two-columns" && (
            <TwoColumns props={data} />
          )}

          {data.template === "list-with-carousel" && (
            <ListWithCarousel props={data} />
          )}

          {data.template === "content-with-image" && (
            <ContentWithImage props={data} />
          )}

          {data.template === "quiz" && <Quiz data={data} />}
        </div>
      </div>
    );
};

export default Page;
